import React, {useState, useRef} from 'react';
import PayOff from '../PayOff/PayOff';
import {Link} from 'react-router-dom';
import './SaveInterest.scss';

function SaveInterest(props) {
    const {info} = props;
    const loanData = info.item;
    console.log(info);
    const [sliderState, setSliderState] = useState(50);
    const [selectState, setSelectState] = useState('aggregate');
    const amortizeMonths = useRef(0);
    const prevSavings = useRef(0);
    const value = sliderState;
    const extraPayment = sliderState * 10;
    const callback = (sliderNumericalValue) => {
        setSliderState(sliderNumericalValue)
    };

    const loanRemaining = parseInt(loanData.loan_aggregate.total_loan_debt);
    const principalDollar = new Intl.NumberFormat().format(loanRemaining);

    function amortizeLoan(a, b, c, d, e) {
        let timeToRepay = 1;
        let amountFinanced = a - b;
        while (amountFinanced > 0 && timeToRepay < 360) {
            amountFinanced = amountFinanced - d - e;
            amountFinanced = amountFinanced * (1 + c / (12 * 100));
            timeToRepay++;
        };
        console.log(timeToRepay, amountFinanced, c);
        return timeToRepay;
    }

    function findHighestRate(l) {
        let empty = l[0]["interest_rate"];
        let name = l[0]["servicer_name"];
        let balance = l[0]["current_balance"];
        for (let c = 1; c < l.length; c++) {
            if (l[c]["interest_rate"] > empty) {
                empty = l[c]["interest_rate"];
                name = l[c]["servicer_name"];
                balance = l[c]["current_balance"];
            } else if (l[c]["interest_rate"] === empty) {
                if (l[c]["current_balance"] > balance) {
                    empty = l[c]["interest_rate"];
                    name = l[c]["servicer_name"];
                    balance = l[c]["current_balance"];
                }
            }
        };
        return {
            name: name,
            empty: empty,
        };
    }

    //Calculating Recommended Loan and Interest Rate
    let sli = loanData.student_loan_info;
    let {name, empty} = findHighestRate(sli);
    let recLoan = sli.find((e) => e["interest_rate"] === empty);
    console.log(recLoan);
    let selectedLoan = selectState === 'aggregate' ? recLoan : (sli.find(e => e["servicer_name"] === selectState) || recLoan);
    let rate = selectState === 'aggregate' ? loanData.loan_aggregate.average_interest_rate : selectedLoan.interest_rate;

    //Calculating Extra Interest Savings
    const loans = loanData.loan_aggregate;
    const aggCurrentDebt = loans.total_loan_debt;
    let currentDebt = selectState === 'aggregate' ? aggCurrentDebt : selectedLoan.current_balance;
    let currentInterestRate = rate;
    const aggLarger = Math.max(loans.total_actual_monthly_payment, loans.total_min_payment);
    const selLarger = Math.max(selectedLoan.optimized_monthly_payment, selectedLoan.minimum_payment);
    let larger = selectState === 'aggregate' ? aggLarger : selLarger;
    const aggMonthsToPayoff = loans.estimated_months_to_payoff;
    const selMonthsToPayoff = parseInt(selectedLoan.current_balance / selectedLoan.est_monthly_payment);
    let estimatedMonthsToPayoff = selectState === 'aggregate' ? aggMonthsToPayoff : selMonthsToPayoff;
    const bip = (larger * estimatedMonthsToPayoff) - currentDebt; //calculated interest based on monthly payments
    const monthlyInterest = bip / estimatedMonthsToPayoff;

    let lowerRateExtraPayment = amortizeLoan(currentDebt, 0, currentInterestRate, larger, extraPayment);
    let howmuch = monthlyInterest * lowerRateExtraPayment
    let savings = bip - howmuch;
    if (savings < 0) {
        savings = 0;
    }
    let ans = parseInt(savings);
    let wer = new Intl.NumberFormat().format(ans);
    console.log(currentInterestRate, lowerRateExtraPayment, savings);

    return (
        <div className="save-interest mr-t30 flex-container flex-wrap">
            <div className="flex-interest">
                <div className="container-heading text-left mr-t10">Save on Interest</div>
                <div className="tile">
                    <div className="interest-text">
                        <div className="paragraph-text">Combining extra payments and refinancing towards</div>
                        <div className="selectInterestDiv">
                            <select value={selectState} onChange={(e) => setSelectState(e.target.value)}>
                                <option value="aggregate">Aggregate</option>
                                {sli.map((loan, i) => (
                                    <option key={i} value={loan.servicer_name}>{loan.servicer_name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="paragraph-text"> has a snowball effect that will save you even more in the long run.</div>
                    </div>
                    <div className="amount-background">
                        <div className="amount-display">
                            <h2 className="amount">${wer}</h2>
                            <h2 className="amount-text">lifetime savings</h2>
                            <div className="interest-button">
                                <Link to={{ pathname: "https://www.alumsum.com/blog/how-current-students-can-save-thousands-in-interest-on-their-student-loans"}} target="_blank"><button style={{ width: '100%', padding: '20px' }} className="btn btn-dashboard btn-secondary">Learn More About Interest</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PayOff onSliderChange={callback} sliderValue={value} name={name} recLoan={recLoan} loans={info}/>
        </div>
    );
}

export default SaveInterest;